import visit from 'unist-util-visit'

import { VisitNode } from './types'

type LiteralVisitNode = VisitNode & {
    depth: number
    tagName: string
}

type HeadingToDivPluginProps = {
    enabled?: boolean
    small?: boolean
}

export const headingToDiv = ({ small, enabled = true }: HeadingToDivPluginProps) => {
    function transformer(tree: VisitNode) {
        if (!enabled) return
        visit(tree, 'heading', (node: LiteralVisitNode) => {
            node.type = 'element'
            node.tagName = 'div'

            const data = node.data || (node.data = {})
            const props = data.hProperties || (data.hProperties = {})

            // @ts-expect-error ignore it
            props.className = `custom-heading-${node.depth}${small ? ' small' : ''}`
        })
    }

    return transformer
}
